// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__2dW-g","spinner1":"Spinner_spinner1__2RNXu"};